import React from "react";
import View from "common/View";
import ListNTPServers from "./List";
import AddNTPServer from "./Add";
import help from "help/viewSysNtp.md";

const options = [
  {
    signal: "add-server",
    label: "Add Server",
  },
];

export const NTPServersAdmin = ({ returnView = null }) =>
  <View
    title="NTP Servers"
    className="container-lg"
    mdHelp={help}
    options={options}
    returnView={returnView}
  >
    <ListNTPServers />
    <AddNTPServer />
  </View>

export default NTPServersAdmin;
